(() => {
  const localDate = date => {
    const pad = number => String(number).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
  };
  const initialize = root => {
    root.querySelectorAll('[data-lp-gift-recipient]').forEach(wrapper => {
      if (wrapper.dataset.lpInitialized) return;
      wrapper.dataset.lpInitialized = 'true';
      const checkbox = wrapper.querySelector('.js-recipient-form-checkbox');
      const email = wrapper.querySelector('input[type="email"]');
      const sendOn = wrapper.querySelector('input[type="date"]');
      if (!checkbox || !email || !sendOn) return;
      const today = new Date();
      const lastDate = new Date(today);
      lastDate.setDate(lastDate.getDate() + 90);
      sendOn.min = localDate(today);
      sendOn.max = localDate(lastDate);
      const syncEmail = () => {
        email.required = checkbox.checked;
        email.setAttribute('aria-required', String(checkbox.checked));
      };
      checkbox.addEventListener('change', syncEmail);
      syncEmail();
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once:true });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
